"use client"
import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)



const CounterSection = () => {
  const sectionRef = useRef(null);
  const countersRef = useRef([]);


  const stat = [
    {
      end: 0,
      suffix: '',
      label: 'Calories',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
          <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
        </svg>
      )
    },
    {
      end: 100,
      suffix: '%',
      label: 'Natural',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
          <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" />
          <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
        </svg>
      )
    },
    {
      end: 20000,
      suffix: 'K +',
      formatter: (value) => `${Math.floor(value / 1000)}K +`,
      label: 'Families',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      end: 80000,
      suffix: '+ Kg',
      formatter: (value) => `${Math.floor(value).toLocaleString()} + Kg`,
      label: 'Sugar replaced',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
          <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
          <path d="M21 3v5h-5" />
          <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
          <path d="M8 16H3v5" />
        </svg>
      )
    }
  ]

 useEffect(() => {
    const ctx = gsap.context(() => {
        countersRef.current.forEach((counter,index) => {
            if(!counter) return;

            const stats = stat[index]
            const object = { value : 0 }

            gsap.to(object, {
                value: stats.end,
                duration: 2,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                    end: 'bottom top',
                    once: true
                },
                onUpdate: () => {
                    counter.textContent = stats.formatter ? stats.formatter(object.value) : Math.floor(object.value).toLocaleString() + stats.suffix
                }
            })
        })
    }, sectionRef)

    const handleLoad = () => ScrollTrigger.refresh();
    window.addEventListener("load", handleLoad)

    if(document.fonts) {
        document.fonts.ready.then(() => ScrollTrigger.refresh())
    }

    return() => {
        window.removeEventListener('load', handleLoad);
        ctx.revert()
    }
 },[])

  return (
    <div
      ref={sectionRef}
      className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6"
    >
      {stat.map((item, index) => (
        <div
          key={index}
          className="group relative overflow-hidden rounded-2xl bg-white border border-[#F0E6D2] p-4 md:p-8 shadow-[0_4px_20px_rgba(194,10,20,0.06)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(194,10,20,0.15)]"
        >
          <span className="pointer-events-none absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-[#C20A14] to-[#8f060d]" />
          <span className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-[#C20A14]/5 transition-transform duration-500 group-hover:scale-150" />
          <div className="relative mb-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#C20A14] to-[#8f060d] text-white shadow-md">
            {item.icon}
          </div>
          <h2
            ref={(el) => (countersRef.current[index] = el)}
            style={{ color: '#C20A14' }}
            className="relative 2xl:text-[36px] text-[26px] max-md:text-[24px] font-bold leading-none"
          >
            0
          </h2>
          <p className="relative mt-2 max-md:text-[16px] text-[20px] font-medium text-[#3a3a3a]">
            {item.label}
          </p>
        </div>
      ))}
    </div>
  )
}

export default CounterSection
